module.exports = __webpack_public_path__ + "img/logo_full.0dd9c09f.png";